import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationService from "../../../../services/NotificationService";
import { Translate } from "../../../Enums/Tranlate";

const AddNotification = () => {
	const [formData, setFormData] = useState({
		title_en: "",
		title_ar: "",
		description_en: "",
		description_ar: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const notificationService = new NotificationService();
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		const item = location?.state || {};
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				title_en: item?.massage_title_en,
				title_ar: item?.massage_title_ar,
				description_en: item?.massage_body_en,
				description_ar: item?.massage_body_ar,
			});
		}
	}, []);

	const submit = () => {
		let data = {
			massage_title_en: formData?.title_en,
			massage_title_ar: formData?.title_ar,
		};
		if (!!formData?.description_en)
			data["massage_body_en"] = formData?.description_en;
		if (!!formData?.description_ar)
			data["massage_body_ar"] = formData?.description_ar;

		setLoading(true);

		notificationService
			.create(data)
			?.then((res) => {
				if (res?.status === 201) {
					toast.success("Notification Added Successfully");
					navigate("/notification");
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<Card>
			<div className="d-flex align-items-center" style={{ gap: "8px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					className="button-back"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/notification")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!isAdd ? Translate[lang]?.view : Translate[lang]?.add}{" "}
					{Translate[lang]?.notification}
				</label>
			</div>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Card.Body>
					<Row>
						<Col md={6}>
							<AvField
								label={Translate[lang].english_title}
								type="text"
								placeholder={Translate[lang].english_title}
								bsSize="lg"
								disabled={!isAdd}
								name="title_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.title_en}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, title_en: e.target.value }))
								}
							/>
						</Col>

						<Col md={6}>
							<AvField
								label={Translate[lang].arabic_title}
								type="text"
								placeholder={Translate[lang].arabic_title}
								value={formData.title_ar}
								name="title_ar"
								disabled={!isAdd}
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, title_ar: e.target.value }))
								}
							/>
						</Col>
						<Col md={6}>
							<label className="d-block">
								{Translate[lang].english_description}
							</label>
							<textarea
								style={{
									border: "1px solid hsl(0, 0%, 80%)",
									padding: "6px 12px",
									width: "100%",
									borderRadius: "0.3rem",
									maxHeight: "200px",
									minHeight: "100px",
									height: " 150px",
								}}
								name="description_en"
								type="text"
								disabled={!isAdd}
								value={formData.description_en}
								placeholder={Translate[lang].english_description}
								onChange={(e) =>
									setFormData((prev) => ({
										...prev,
										description_en: e.target.value,
									}))
								}
							/>
						</Col>
						<Col md={6}>
							<label className="d-block">
								{Translate[lang].arabic_description}
							</label>
							<textarea
								style={{
									border: "1px solid hsl(0, 0%, 80%)",
									padding: "6px 12px",
									width: "100%",
									borderRadius: "0.3rem",
									maxHeight: "200px",
									minHeight: "100px",
									height: " 150px",
								}}
								name="description_ar"
								type="text"
								disabled={!isAdd}
								value={formData.description_ar}
								placeholder={Translate[lang].arabic_description}
								onChange={(e) =>
									setFormData((prev) => ({
										...prev,
										description_ar: e.target.value,
									}))
								}
							/>
						</Col>
						<Col md={6}>
							{isAdd && (
								<Button
									variant="primary"
									className="w-100 mt-3"
									type="submit"
									disabled={loading}>
									{Translate[lang].send}
								</Button>
							)}
							{!isAdd && (
								<Button
									variant="primary"
									className="w-100 mt-3"
									type="button"
									onClick={() => navigate("/notification")}>
									{Translate[lang].cancel}
								</Button>
							)}
						</Col>
					</Row>
				</Card.Body>
			</AvForm>
		</Card>
	);
};

export default AddNotification;
